(function(){
  var rm=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine=window.matchMedia('(hover:hover) and (pointer:fine)').matches;

  function init(){
    /* progress bar */
    var bar=document.createElement('div');bar.id='g99-progress';document.body.appendChild(bar);
    /* Horizon scrolls inside .page-wrapper on desktop (>=990px) and the document on mobile */
    var desk=window.matchMedia('(min-width: 990px)');
    function scroller(){return (desk.matches&&document.querySelector('.page-wrapper'))||document.scrollingElement||document.documentElement}
    function onScroll(){
      var el=scroller(),y=el.scrollTop,h=el.scrollHeight-el.clientHeight;
      bar.style.width=(h>0?y/h*100:0)+'%';
      document.body.classList.toggle('g99-scrolled',y>40);
    }
    document.addEventListener('scroll',onScroll,{passive:true,capture:true});onScroll();

    /* magnetic buttons */
    if(fine&&!rm){
      document.addEventListener('mousemove',function(e){
        var b=e.target.closest&&e.target.closest('.button');
        document.querySelectorAll('.button[data-g99m]').forEach(function(x){if(x!==b){x.style.transform='';x.removeAttribute('data-g99m')}});
        if(b){var r=b.getBoundingClientRect();b.setAttribute('data-g99m','1');
          b.style.transform='translate('+((e.clientX-r.left-r.width/2)*.2)+'px,'+((e.clientY-r.top-r.height/2)*.3)+'px)'}
      });
    }

    /* tilt on product cards */
    function bindTilt(root){
      if(!fine||rm)return;
      (root||document).querySelectorAll('product-card').forEach(function(c){
        if(c.dataset.g99t)return;c.dataset.g99t='1';c.classList.add('g99-tilt');
        c.addEventListener('mousemove',function(e){
          var r=c.getBoundingClientRect(),x=(e.clientX-r.left)/r.width,y=(e.clientY-r.top)/r.height;
          c.style.transform='perspective(800px) rotateX('+((.5-y)*8)+'deg) rotateY('+((x-.5)*8)+'deg) translateZ(0)';
          c.style.setProperty('--mx',x*100+'%');c.style.setProperty('--my',y*100+'%');
        });
        c.addEventListener('mouseleave',function(){c.style.transform=''});
      });
    }
    bindTilt();

    /* scroll reveal */
    var io=new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting){en.target.classList.add('g99-in');io.unobserve(en.target)}})},{threshold:.12});
    function bindReveal(root){
      (root||document).querySelectorAll('.shopify-section:not(:first-child) > :not(.x99-scene), product-card').forEach(function(el,i){
        if(el.dataset.g99r)return;el.dataset.g99r='1';
        el.style.setProperty('--d',(i%4)*.08+'s');el.classList.add('g99-reveal');io.observe(el);
      });
    }
    bindReveal();

    /* watch for dynamically added cards */
    new MutationObserver(function(){bindTilt();bindReveal()}).observe(document.body,{childList:true,subtree:true});

    /* cart icon bounce on add */
    document.addEventListener('submit',function(e){
      var f=e.target;if(f&&f.action&&f.action.indexOf('/cart/add')>-1){
        var ic=document.querySelector('cart-icon,.cart-icon,[href="/cart"]');
        if(ic){ic.classList.remove('g99-bounce');void ic.offsetWidth;ic.classList.add('g99-bounce')}
      }
    },true);

    /* trust badges on product page */
    if(/\/products\//.test(location.pathname)){
      var target=document.querySelector('product-form-component, form[action*="/cart/add"]');
      if(target&&!document.querySelector('.g99-trust')){
        var t=document.createElement('div');t.className='g99-trust';
        t.innerHTML=
          '<div><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M10.5 9l2-1.5V16"/></svg>1,000 made</div>'+
          '<div><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M5.6 5.6l12.8 12.8"/></svg>Collector box</div>'+
          '<div><svg viewBox="0 0 24 24"><path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z"/><path d="M9 12l2 2 4-4"/></svg>Secure checkout</div>';
        target.parentNode.insertBefore(t,target.nextSibling);
      }
    }
  }
  if(document.body)init();else document.addEventListener('DOMContentLoaded',init);
})();
